package club.srams.website.pages

import androidx.compose.runtime.Composable
import club.srams.website.SubheadlineTextStyle
import club.srams.website.components.layouts.PageLayoutData
import club.srams.website.components.widgets.Carousel
import club.srams.website.toSitePalette
import com.varabyte.kobweb.compose.css.AlignContent
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.alignContent
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div

@InitRoute
fun initTailgateSwapPage(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData("Tailgate Swap"))
}

@Page
@Layout(".components.layouts.PageLayout")
@Composable
fun TailgateSwapPage() {
    Row() {
        SpanText(
            "Annual Tailgate Swap"
            , modifier = Modifier
                .fillMaxWidth()
                .fontSize(3.cssRem)
                .lineHeight(1.2)
                .textAlign(TextAlign.Center)
                .color(
                    when (ColorMode.current) {
                        ColorMode.LIGHT -> Colors.Black
                        ColorMode.DARK -> Colors.White
                    }
                )
        )
    }

    Row(
        modifier = Modifier
            .fillMaxWidth()
            .alignContent(AlignContent.Center)
        , horizontalArrangement = Arrangement.Center
    ) {
        Image(
            src = "/images/tailgate/2026_tailgate_poster.jpg",
            alt = "SRAMS poster",
            modifier = Modifier
                .height(1000.px)
                .width(700.px)
                .margin {
                    bottom(24.px)
                    top(24.px)
                }
        )
    }

    Row(HeroContainerStyle.toModifier()) {
        Box {
            val sitePalette = ColorMode.current.toSitePalette()

            Column(Modifier.gap(2.cssRem)) {
                Div(SubheadlineTextStyle.toAttrs()) {
                    SpanText(
                        "2025 Tailgate Swap", Modifier.color(
                            when (ColorMode.current) {
                                ColorMode.LIGHT -> Colors.Black
                                ColorMode.DARK -> Colors.White
                            }
                        )
                    )
                }
            }
        }

        Div(
        ) {
            Column {

                Carousel(
                    `2025_tailgate_swap`
                    , modifier = Modifier.width(500.px).height(400.px)
                )
            }
        }
    }
}

private val `2025_tailgate_swap` = listOf<Pair<String,String>>(
    Pair(
        "/images/tailgate/2025/image_1.jpg"
        , "2025 Annual Tailgate Swap"
    )
    , Pair(
        "/images/tailgate/2025/image_2.jpg"
        , "2025 Annual Tailgate Swap"
    )
    , Pair(
        "/images/tailgate/2025/image_3.jpg"
        , "2025 Annual Tailgate Swap"
    )
    , Pair(
        "/images/tailgate/2025/image_4.jpg"
        , "2025 Annual Tailgate Swap"
    )
    , Pair(
        "/images/tailgate/2025/image_5.jpg"
        , "2025 Annual Tailgate Swap"
    )
    , Pair(
        "/images/tailgate/2025/image_6.jpg"
        , "2025 Annual Tailgate Swap"
    )
    , Pair(
        "/images/tailgate/2025/image_7.jpg"
        , "2025 Annual Tailgate Swap"
    )
    , Pair(
        "/images/tailgate/2025/image_8.jpg"
        , "2025 Annual Tailgate Swap"
    )
    , Pair(
        "/images/tailgate/2025/image_9.jpg"
        , "2025 Annual Tailgate Swap"
    )
    , Pair(
        "/images/tailgate/2025/image_10.jpg"
        , "2025 Annual Tailgate Swap"
    )
    , Pair(
        "/images/tailgate/2025/image_11.jpg"
        , "2025 Annual Tailgate Swap"
    )
)